import {
  CREATE_DESIGN_SUCCESS,
  CREATE_DESIGN_FAILED,
  CREATE_ITEM_SUCCESS,
  CREATE_ITEM_DETAILS_SUCCESS,
  CREATE_ITEM_FAILED,
  CREATE_ITEM_PRODUCT_SUCCESS,
  CREATE_ITEM_PRODUCT_FAILED,
  REMOVE_ITEM_FROM_DESIGN_SUCCESS,
  REMOVE_ITEM_FROM_DESIGN_FAILED,
  CREATE_CONFIG_SUCCESS,
  CREATE_CONFIG_FAILED,
  CREATE_CONTAINER_SUCCESS,
  ALL_DONE,
  IS_FAILED,
  VIEW_ACCESSORIES,
  IS_ATC_START,
} from '../actions/designActions/actionTypes';
import {
  CART_SAVE_FAILED,
  APP_MOUNT,
} from '../actions/actionTypes';

export const initialState = {
  containerId: null,
  design: null,
  errors: { designApiError: false },
  items: [],
  itemDetails: [],
  newConfiguration: [],
  newItem: [],
  allDone: false,
  designFailed: false,
  viewAccessories: true,
  isAtcStart: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_MOUNT: {
      return {
        ...initialState,
      };
    }
    case CREATE_DESIGN_SUCCESS:
    {
      return {
        ...state,
        design: action.payload.design,
        items: [],
        itemDetails: [],
        newItem: [],
        newConfiguration: [],
      };
    }
    case CREATE_CONTAINER_SUCCESS:
    {
      return {
        ...state,
        containerId: action.payload.containerId,
      };
    }
    case CREATE_ITEM_SUCCESS: {
      return {
        ...state,
        newItem: [...state.newItem,
          action.payload],
      };
    }
    case CREATE_ITEM_DETAILS_SUCCESS: {
      return {
        ...state,
        itemDetails: [...state.itemDetails,
          ...action.payload],
      };
    }
    case CREATE_CONFIG_SUCCESS: {
      return {
        ...state,
        newConfiguration: [...state.newConfiguration,
          action.payload.config],
      };
    }
    case CREATE_ITEM_PRODUCT_SUCCESS: {
      return {
        ...state,
        items: [
          ...state.items,
          action.payload.item,
        ],
        newItem: null,
        newConfiguration: [],
      };
    }
    case REMOVE_ITEM_FROM_DESIGN_SUCCESS: {
      const itemsToKeep = state.items.filter(item => item.itemId !== action.payload.id);
      return {
        ...state,
        items: itemsToKeep,
      };
    }
    case ALL_DONE: {
      return {
        ...state,
        allDone: action.payload,
      };
    }

    case IS_ATC_START: {
      return {
        ...state,
        isAtcStart: action.payload,
      };
    }
   
    case IS_FAILED: {
      return {
        ...state,
        designFailed: action.payload,
      };
    }

    case VIEW_ACCESSORIES: {
      return {
        ...state,
        viewAccessories: action.payload,
      };
    }
    case CREATE_DESIGN_FAILED:
    case CREATE_ITEM_FAILED:
    case CREATE_ITEM_PRODUCT_FAILED:
    case CREATE_CONFIG_FAILED:
    case CART_SAVE_FAILED:
    case REMOVE_ITEM_FROM_DESIGN_FAILED: {
      return {
        ...state,
        designFailed: true,
      };
    }
    default:
      return state;
  }
};
